// 订单管理
const api = {
  list: {
    url: '/staff_mall/cityarea/get?id=0',
    type: 'GET',
    parameter: {}
  },
  get: {
    url: '/staff_mall/cityarea/get',
    type: 'get',
    parameter: {}
  }
}

export default api



// WEBPACK FOOTER //
// ./src/components/vue-area/api.js